module.exports = __webpack_public_path__ + "static/2007-header-466cdbcfbcf1621ef7cb32b1b93240bb.png";